import { registerSW } from 'virtual:pwa-register';

// registerType is 'prompt' — surface an update toast instead of force-reloading
// a developer mid-triage.
export function setupPwa(onNeedRefresh: (update: () => void) => void) {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() { onNeedRefresh(() => void updateSW(true)); },
    onOfflineReady() {},
  });
  return updateSW;
}
